import { render, staticRenderFns } from "./PasoSeisComponent.vue?vue&type=template&id=442aed3f"
import script from "./PasoSeisComponent.vue?vue&type=script&lang=js"
export * from "./PasoSeisComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports